import React from 'react'
import { Alert } from 'react-bootstrap'
import {
  BooleanRadioButtonField, MultiLineField, yesNoDataSource, AnzicFieldMulti, TextRadioButtonField, validateFieldsEx, IField,
} from '../../../../shared/fields'
import { ApplicationModel } from '../../../../models/ApplicationModel'
import { AustraliaResearchChoices } from '../../../../shared/Utility'
import EMDGAccordion from '../../../../shared/EMDGAccordion'

export interface Props {
    model: ApplicationModel
    onChange: { (changes: Partial<ApplicationModel>, callback?: { (): any }): any }
    visible: boolean
    preview?: boolean
}

export interface State {

}

export default class IpContainer extends React.Component<Props, State> implements IField {
  isTrademarked: BooleanRadioButtonField
  isUsedInAustralia: BooleanRadioButtonField
  describeUseInAustralia: MultiLineField
  intellectualPropertyOrKnowHowRelatesToTrademark: TextRadioButtonField
  describeResearchInAustraliaIpKnowHow: MultiLineField

  constructor(props: Props) {
    super(props)

    this.state = {

    }
  }

  componentDidUpdate(prevProps: Props) {
    const { model, onChange, visible } = this.props

    if (visible
            && (model.isTrademarked !== prevProps.model.isTrademarked)) {
      onChange({
        isUsedInAustralia: null,
        intellectualPropertyOrKnowHowRelatesToTrademark: null,
        describeResearchInAustraliaIpKnowHow: null,
        describeUseInAustralia: null,
      })
    }

    if (visible
            && (model.isUsedInAustralia !== prevProps.model.isUsedInAustralia)) {
      onChange({ describeUseInAustralia: null })
    }

    if (visible
            && (model.intellectualPropertyOrKnowHowRelatesToTrademark === AustraliaResearchChoices.None
                || prevProps.model.intellectualPropertyOrKnowHowRelatesToTrademark === AustraliaResearchChoices.None)
                && model.describeResearchInAustraliaIpKnowHow !== null) {
      onChange({ describeResearchInAustraliaIpKnowHow: null })
    }

    // Check if Q78.b is empty or has spaces
    if (model.describeUseInAustralia === null || model.describeUseInAustralia.match(/^\s*$/)) {
        model.describeUseInAustralia = null
    }
    // Check if Q77.a is empty or has spaces
    if (model.describeResearchInAustraliaIpKnowHow === null || model.describeResearchInAustraliaIpKnowHow.match(/^\s*$/)) {
        model.describeResearchInAustraliaIpKnowHow = null
    }
  }

  validate(callback: { (res: boolean): any }, focus?: boolean) {
    const { model } = this.props
    if (model.intellectualPropertyOrKnowHowRelatesToTrademark === AustraliaResearchChoices.None || model.isUsedInAustralia === false) {
        callback && callback(false); // don't ever continue!
        return;
    } 
    validateFieldsEx(
      focus,
      callback,
      this.isTrademarked,
      this.isUsedInAustralia,
      this.describeUseInAustralia,
      this.intellectualPropertyOrKnowHowRelatesToTrademark,
      this.describeResearchInAustraliaIpKnowHow,
    )
  }

  render() {
    const ipWorkdoneDataSource = [
      { value: AustraliaResearchChoices.Wholly, label: 'Wholly research or work done in Australia' },
      { value: AustraliaResearchChoices.Substantially, label: 'Substantially research or work done in Australia' },
      { value: AustraliaResearchChoices.None, label: 'None of the above' },
    ]

    const {
      model, onChange, visible, preview,
    } = this.props
    return (
      visible && (
        <div style={{ marginTop: '30px' }}>
          { preview && <h4>Intellectual property/know-how</h4>}
          <EMDGAccordion expanded header="Intellectual property/know-how">
            <BooleanRadioButtonField
              ref={(r) => { this.isTrademarked = r }}
              id="isTrademarked"
              label="78. Does the intellectual property or know-how relate to a trademark?"
              value={model.isTrademarked}
              onChange={(isTrademarked) => onChange({ isTrademarked })}
              required={visible}
              dataSource={yesNoDataSource}
              preview={preview}
              description={(
                <i>
                  For intellectual property or know-how to be eligible, it must be of substantially Australian origin.
                </i>
              )}
            />
            {model.isTrademarked && (
              <>
                <BooleanRadioButtonField
                  ref={(r) => { this.isUsedInAustralia = r }}
                  id="isUsedInAustralia"
                  label="78.a Was the trademark first used in Australia or has it increased in significance or value because of being used in Australia? "
                  value={model.isUsedInAustralia}
                  onChange={(isUsedInAustralia) => onChange({ isUsedInAustralia })}
                  required={visible && model.isTrademarked}
                  dataSource={yesNoDataSource}
                  preview={preview}
                />
                {model.isUsedInAustralia && (
                <MultiLineField
                  ref={(r) => { this.describeUseInAustralia = r }}
                  id="describeUseInAustralia"
                  label="78.b Provide further information to support your answer."
                  value={model.describeUseInAustralia}
                  onChange={(describeUseInAustralia) => onChange({ describeUseInAustralia })}
                  required={visible && model.isUsedInAustralia}
                  maxLength={1000}
                  preview={preview}
                />
                )}
                {model.isUsedInAustralia === false && (
                <Alert className="emdg-page-alerts emdg-page-alerts--error ">
                  You are
                  {' '}
                  <b>not</b>
                  {' '}
                  eligible to apply for a grant as you do not have eligible intellectual property or know-how.
                </Alert>
                )}

              </>
            )}
            {model.isTrademarked === false && (
              <>
                <TextRadioButtonField
                  ref={(r) => { this.intellectualPropertyOrKnowHowRelatesToTrademark = r }}
                  id="intellectualPropertyOrKnowHowRelatesToTrademark"
                  label="79. Does the intellectual property or know-how relate to any other thing, and is it the result: "
                  value={model.intellectualPropertyOrKnowHowRelatesToTrademark}
                  onChange={(intellectualPropertyOrKnowHowRelatesToTrademark) => onChange({ intellectualPropertyOrKnowHowRelatesToTrademark })}
                  required={model.isTrademarked === false}
                  block
                  dataSource={ipWorkdoneDataSource}
                  preview={preview}
                />

                {!!model.intellectualPropertyOrKnowHowRelatesToTrademark && (
                <>
                  {model.intellectualPropertyOrKnowHowRelatesToTrademark === AustraliaResearchChoices.None && (
                    <Alert className="emdg-page-alerts emdg-page-alerts--error ">
                      You are <b>not</b> eligible to apply for a grant as you do not have eligible intellectual property or know-how.
                    </Alert>
                  )}
                  {model.intellectualPropertyOrKnowHowRelatesToTrademark !== AustraliaResearchChoices.None && (
                  <MultiLineField
                    ref={(r) => { this.describeResearchInAustraliaIpKnowHow = r }}
                    id="describeResearchInAustraliaIpKnowHow"
                    label="79.a Provide further information to support your answer."
                    value={model.describeResearchInAustraliaIpKnowHow}
                    onChange={(describeResearchInAustraliaIpKnowHow) => onChange({ describeResearchInAustraliaIpKnowHow })}
                    required={!!model.intellectualPropertyOrKnowHowRelatesToTrademark && model.intellectualPropertyOrKnowHowRelatesToTrademark !== AustraliaResearchChoices.None}
                    maxLength={1000}
                    preview={preview}
                  />
                  )}
                </>
                )}
              </>
            )}
          </EMDGAccordion>
        </div>
      )
    )
  }
}
